var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.70598 19.9998C1.26919 19.9998 0.832409 19.8334 0.499701 19.4999C-0.166567 18.8336 -0.166567 17.7536 0.499701 17.0873L17.0873 0.499701C17.7536 -0.166567 18.8336 -0.166567 19.5007 0.499701C20.1678 1.16597 20.167 2.24599 19.5007 2.91226L2.91226 19.4999C2.5787 19.8334 2.14277 19.9998 1.70598 19.9998Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2936 19.9998C17.8568 19.9998 17.42 19.8334 17.0873 19.4999L0.499701 2.91226C-0.166567 2.24599 -0.166567 1.16597 0.499701 0.499701C1.16597 -0.166567 2.24599 -0.166567 2.91311 0.499701L19.5007 17.0873C20.167 17.7536 20.167 18.8336 19.5007 19.4999C19.1672 19.8334 18.7312 19.9998 18.2944 19.9998H18.2936Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseVideo);
export default __webpack_public_path__ + "static/media/closeVideo.21bfaa1fa87e6c34ac67df88dae7dad1.svg";
export { ForwardRef as ReactComponent };